import { FC } from 'react'

import VideoPlayer from '@/components/VideoPlayer'
import { Button } from '@/components/ui'

interface IFileSidebarProps {
	video?: {
		src: string
		type: string
	}
	isShotlistLoading: boolean
	onSaveAndClose: () => void
	source?: string
}

const FileSidebar: FC<IFileSidebarProps> = ({
	video,
	isShotlistLoading,
	onSaveAndClose,
	source
}) => {
	return (
		<section className='h-screen flex-[0_1_25%] flex flex-col border-r'>
			<div className='flex-[1_1_auto]'>
				{video?.src && (
					<VideoPlayer
						src={video?.src}
						type={video?.type}
						isLoading={isShotlistLoading}
						source={source}
					/>
				)}
			</div>
			{!isShotlistLoading && (
				<div className='p-5'>
					<Button
						className='text-white bg-black px-5 py-[10px] rounded-[8px] hover:bg-gray-500 active:bg-gray-400 active:scale-y-90'
						onClick={onSaveAndClose}
					>
						Save and close
					</Button>
				</div>
			)}
		</section>
	)
}

export default FileSidebar
